<script>

/**
 * Automodal 
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el controld de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import {archetype, automodalHandler} from './archetype'

export default {
    name: 'presenciasAutomodal',
    props: {
        tipoDefault: {
            type: String,
            default: 'directo'
        },
        conceptId: {
            type: [String, Number],
        },
        archetype: {
            type: [Array, Object],
            default: () => archetype
        }
    },
    data: () => {
        return {
            form: {
                id: null,
            },
            asides: {
                usuario: [],
                lunch_cedes: [],
                lunch_grupo: [],
            },
            filteredGroupOptions: []
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype, itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(itemsRow);
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO

                    if(item.key == 'usuario_id_pk'){
                        item.options = _.clone(this.asides.usuario)
                        item.readonly = (this.form.id) ? true : false
                    }

                    if(item.key == 'lunch_cedes_id'){
                        item.options = _.clone(this.asides.lunch_cedes)
                        item.readonly = (this.form.id) ? true : false
                    }

                    if(item.key == 'lunch_grupo_id'){
                        item.options = _.filter(this.asides.lunch_grupo, item => {
                            return (parseInt(item.lunch_cedes_id) == parseInt(this.form.lunch_cedes_id))
                        })
                        item.readonly = (this.form.id || !item.options.length) ? true : false
                    }

                    if(item.key == 'tipo'){
                        item.default = this.tipoDefault
                        // item.readonly = true
                    }

                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            if(_.isObjectLike(asides)){
                this.asides.usuario                      = asides.usuario
                this.asides.lunch_cedes                      = asides.lunch_cedes
                this.asides.lunch_grupo                      = asides.lunch_grupo
            }
        },

        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },

        onHidden(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        }

    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form"  ref="automodal" size="sm" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="false" 
        :allow-delete="true"
        :form-key="formArchetypeMD5"
        @refresh="refresh()" 
        @defined="checkAsides()" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>